import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MwcModalRef } from 'mwc/modal';

export interface PromptItem {
  id: number;
  text: string;
  selected: boolean;
}

@Component({
  selector: 'app-select-prompts-modal',
  templateUrl: './select-prompts-modal.component.html',
  styleUrls: ['./select-prompts-modal.component.scss']
})
export class SelectPromptsModalComponent implements OnInit {
  @Output() confirmEmitter: EventEmitter<string[]> = new EventEmitter();

  maxPromptsAllowed = 2;
  prompts: PromptItem[] = [];

  constructor(private modal: MwcModalRef) {}

  ngOnInit(): void {
    const data = this.modal.getConfig().mwcData;
    const existingPrompts: string[] = data?.existingPrompts || [];
    const promptList: string[] = data?.prompts || [];
    this.prompts = promptList.map((text, index) => ({
      id: index + 1,
      text,
      selected: existingPrompts.includes(text)
    }));
    this.maxPromptsAllowed = existingPrompts.length > 0 ? existingPrompts.length : this.maxPromptsAllowed;
  }

  get selectedCount(): number {
    return this.prompts.filter(p => p.selected).length;
  }

  get remainingCount(): number {
    return this.maxPromptsAllowed - this.selectedCount;
  }

  get alertType(): 'warning' | 'success' {
    return this.selectedCount >= this.maxPromptsAllowed ? 'success' : 'warning';
  }

  isDisabled(prompt: PromptItem): boolean {
    return !prompt.selected && this.selectedCount >= this.maxPromptsAllowed;
  }

  togglePrompt(prompt: PromptItem, checked: boolean): void {
    if (this.isDisabled(prompt) && checked) return;
    prompt.selected = checked;
  }

  cancel(): void {
    this.modal.destroy();
  }

  save(): void {
    const selected = this.prompts.filter(p => p.selected).map(p => p.text);
    this.confirmEmitter.emit(selected);
  }
}
